import { RootState } from '@redux/store'

export const profileSelector = ({ profile }: RootState) => profile
